export const CONVERSATION = 'conversation'
export const SILENCE = 'silence'

export const PRETTY_TRANSCRIPT = 'pretty-transcript'
export const POSTPROCESSED_TRANSCRIPT = 'postprocessed-transcript'
export const REALTIME_TRANSCRIPT = 'realtime-transcript'
export const HYPOTHESIS_TRANSCRIPT = 'hypothesis-transcript'

export const allTranscriptOptions = [
  { value: PRETTY_TRANSCRIPT, label: 'Pretty Transcript' },
  { value: POSTPROCESSED_TRANSCRIPT, label: 'Post-Processed Transcript' },
  { value: REALTIME_TRANSCRIPT, label: 'Real-Time Transcript' },
  { value: HYPOTHESIS_TRANSCRIPT, label: 'Hypothesis Transcript' },
]
export const transcriptDisplayValues = {
  [PRETTY_TRANSCRIPT]: {
    showPrettyTranscript: true,
    showPostcallTranscript: false,
    showHypothesis: false,
  },
  [POSTPROCESSED_TRANSCRIPT]: {
    showPrettyTranscript: false,
    showPostcallTranscript: true,
    showHypothesis: false,
  },
  [REALTIME_TRANSCRIPT]: {
    showPrettyTranscript: false,
    showPostcallTranscript: false,
    showHypothesis: false,
  },
  [HYPOTHESIS_TRANSCRIPT]: {
    showPrettyTranscript: false,
    showPostcallTranscript: false,
    showHypothesis: true,
  },
}
